import { useQuery } from "@tanstack/react-query";
import getApiServices from "../../services/getApiService";
import { getCustomerDetail, getOrPostSensors } from "../../constants/api-end-pionts";

export const useCustomer = (userId: string | null) => {
  const url = `${getCustomerDetail}/${userId}`;

  return useQuery({
    queryKey: ["user_data"],
    queryFn: () => getApiServices(url),
    enabled: !!userId,
  });
};

export const useAllSensors = (enabled: boolean) => {
  return useQuery({
    queryKey: ["all_sensors"],
    queryFn: () => getApiServices(getOrPostSensors),
    enabled,
  });
};
